import React from 'react';
import { Modal, Text } from '@goodrx/matisse';

export const HmaModalCopy = () => (
  <Text>
    In order to show you medication prices and discount coupons, send you refill reminders, and to support and contact
    you about our services and other promotional offers, we may share your data with partners, affiliates and third
    parties.
  </Text>
);

export const HmaInfoModal: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => (
  <Modal open={isOpen} title="HIPAA Marketing Authorization" minWidth={320} maxWidth={400} onClose={onClose}>
    <Modal.Body>
      <HmaModalCopy />
    </Modal.Body>
  </Modal>
);
